import { formatPickupReviewDriverDisplay } from '../../../content';

type DispatchedDriver = {
  driverName?: string;
  driverNumber?: string;
};

export const getDriverDisplayForPickup = (
  prevAssignedDriver: string | null | undefined,
  dispatchedDrivers: DispatchedDriver[] = []
): string => {
  if (!prevAssignedDriver) {
    return '';
  }

  const driver = dispatchedDrivers.find(
    (item) => item.driverNumber?.toUpperCase() === prevAssignedDriver.toUpperCase()
  );

  if (driver?.driverName && driver?.driverNumber) {
    return formatPickupReviewDriverDisplay(driver.driverName, driver.driverNumber);
  }

  return prevAssignedDriver;
};
